import { BackrsUser, FeaturedIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Typography } from '@mui/material';

import { PlaylistCard, PlaylistCardProps } from './PlaylistCard';
import { PLAYLIST_CARD_LIST_VIEW_WIDTH } from '../constants/priorities.constants';

const PLAYLIST_EMPTY_STATE_SECTION_STRINGS =
  appStrings.modules.priorities.playlistsSection.emptyState;

type PlaylistSectionEmptyStateProps = Readonly<{
  openNewPlaylistDialog: (preLoadedTitle?: string) => void;
  currentUser?: BackrsUser;
}>;

export const PlaylistSectionEmptyState = ({
  openNewPlaylistDialog,
  currentUser,
}: PlaylistSectionEmptyStateProps) => {
  const basePlaylistParams = {
    id: 0,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: currentUser?.id || null,
    user: currentUser,
    created_by: currentUser?.id || null,
  };

  const clipboardPlusIcon = (
    <FeaturedIcon
      iconName="ClipboardPlus"
      size="md"
      borderColor="Colors/Base/Black"
      color="Colors/Base/Black"
    />
  );

  const emptyStatePlaylists: PlaylistCardProps[] = [
    /**
     * BUILD PLAYLIST PLAYLIST
     */
    {
      playlist: {
        ...basePlaylistParams,
        title: PLAYLIST_EMPTY_STATE_SECTION_STRINGS.buildPlaylist.title,
        description: PLAYLIST_EMPTY_STATE_SECTION_STRINGS.buildPlaylist.description,
        total_tasks: 0,
        completed_tasks: 0,
      },
      showDateOrDescription: 'DESCRIPTION',
      playlistCardWidth: PLAYLIST_CARD_LIST_VIEW_WIDTH,
      topLeftElement: { type: 'IMAGE' as const, imageUrl: '/images/playlist-list-drawer.svg' },
      topRightElement: { type: 'ELEMENT' as const, element: <></> },
      bottomElement: {
        type: 'BUTTON_WITH_ICON' as const,
        iconName: 'Plus' as const,
        label: PLAYLIST_EMPTY_STATE_SECTION_STRINGS.buildPlaylist.buttonLabel,
      },
      onClick: () => openNewPlaylistDialog(),
      opacity: undefined,
    },

    /**
     * COLLEGE SHORTLIST PLAYLIST
     */
    {
      playlist: {
        ...basePlaylistParams,
        title: PLAYLIST_EMPTY_STATE_SECTION_STRINGS.collegeShortlist.title,
        description: '',
        total_tasks: 1,
        completed_tasks: 0,
        user_id: 0,
      },
      playlistCardWidth: PLAYLIST_CARD_LIST_VIEW_WIDTH,
      showDateOrDescription: 'DESCRIPTION',
      topLeftElement: { type: 'DONUT' as const },
      topRightElement: { type: 'ELEMENT' as const, element: clipboardPlusIcon },
      bottomElement: {
        type: 'ELEMENT' as const,
        element: (
          <Typography variant="text-sm-regular" mt={({ backrs }) => backrs.spacing['spacing-md']}>
            {PLAYLIST_EMPTY_STATE_SECTION_STRINGS.collegeShortlist.description}
          </Typography>
        ),
      },
      onClick: () =>
        openNewPlaylistDialog(PLAYLIST_EMPTY_STATE_SECTION_STRINGS.collegeShortlist.title),
      opacity: 0.5,
    },

    /**
     * SCHOLARSHIP OPPORTUNITIES PLAYLIST
     */
    {
      playlist: {
        ...basePlaylistParams,
        title: PLAYLIST_EMPTY_STATE_SECTION_STRINGS.scholarshipOpportunities.title,
        description: '',
        total_tasks: 1,
        completed_tasks: 0,
        user_id: 0,
      },
      playlistCardWidth: PLAYLIST_CARD_LIST_VIEW_WIDTH,
      showDateOrDescription: 'DESCRIPTION',
      topLeftElement: { type: 'DONUT' as const },
      topRightElement: { type: 'ELEMENT' as const, element: clipboardPlusIcon },
      bottomElement: {
        type: 'ELEMENT' as const,
        element: (
          <Typography variant="text-sm-regular" mt={({ backrs }) => backrs.spacing['spacing-md']}>
            {PLAYLIST_EMPTY_STATE_SECTION_STRINGS.scholarshipOpportunities.description}
          </Typography>
        ),
      },
      onClick: () =>
        openNewPlaylistDialog(PLAYLIST_EMPTY_STATE_SECTION_STRINGS.scholarshipOpportunities.title),
      opacity: 0.5,
    },
  ];

  return (
    <>
      {emptyStatePlaylists.map((playlist) => (
        <PlaylistCard key={playlist.playlist.id} {...playlist} />
      ))}
    </>
  );
};
